import { Link } from "react-router-dom";

export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
    <path d="M16 1.5 28.6 8.75v14.5L16 30.5 3.4 23.25V8.75Z" fill="#FF5A1F" />
    <path fill="#0F1012" fillRule="evenodd" d="M16 7.5 23.4 24h-3.9l-1.4-3.3h-4.2L12.5 24H8.6Zm0 7.2-1.3 3.1h2.6Z" />
  </svg>
);

export const Logo = ({ testId = "logo-link" }) => (
  <Link to="/" data-testid={testId} className="group flex items-center gap-2.5" aria-label="Assemble Pro home">
    <span className="transition-transform duration-500 group-hover:rotate-[60deg]"><LogoMark /></span>
    <span className="font-display text-2xl font-black uppercase leading-none tracking-tight">
      Assemble<span className="text-[var(--orange)]">Pro</span>
    </span>
  </Link>
);
